// Pagination utilities previously from @/store/pagination

export type PaginationParams = {
  page_size?: number;
  cursor?: string;
};

export type PaginationResponse<T> = {
  data: T[];
  has_next: boolean;
  next_url?: string;
};

/** Pulls the cursor out of a response's `next_url`. The base is a placeholder. */
export const cursorFromNextUrl = (nextUrl: string | undefined): string | undefined => {
  if (!nextUrl) {
    return undefined;
  }

  return new URL(nextUrl, "https://prequel.local").searchParams.get("cursor") ?? undefined;
};

export const DEFAULT_PAGE_SIZE = 50;
export const MAX_PAGE_SIZE = 100;

/**
 * Parses a number parameter from a string, with validation
 */
export function parseNumberParam(
  value: string | null,
  defaultValue: number,
  options?: { min?: number; max?: number; showToastOnError?: boolean },
): number {
  if (value === null) {
    return defaultValue;
  }

  const parsed = parseInt(value, 10);
  if (isNaN(parsed)) {
    return defaultValue;
  }

  if (options?.min !== undefined && parsed < options.min) {
    return options.min;
  }

  if (options?.max !== undefined && parsed > options.max) {
    return options.max;
  }

  return parsed;
}
